// extracted by mini-css-extract-plugin
export default {"DateColumn":"MessagesList__DateColumn-idmDz","MessageRead":"MessagesList__MessageRead-cuyZL"};